import React from 'react'
import ReactDOM from 'react-dom';
import io from 'socket.io-client';
import { Toast } from '../../components/Toast';

export default (async () => {

  if (process.env.REACT_APP_DEVELOPMENT_MODE !== "true" ) {
    return;
  }

  let hasOpenedNotifier = false;
  let hasOpenedBuildNotifier = false;
  var scrollPos = parseFloat(localStorage.getItem('scroll-y') || '0') || 0;
  if (scrollPos) window.scrollTo(0, scrollPos)

  var disconnected = false
  var socket = io(`${process.env.REACT_APP_SOCKET_URL}:${process.env.REACT_APP_SOCKET_PORT}` || '', {
    reconnectionAttempts: 1
  })
  socket.on('connect', function(){
    console.group("better wordpress - connected")
  });
  socket.on('event', function(data: any){
    console.log('event.', data)
  });
  socket.on('disconnect', function(){
    console.log('disconnected.')
    disconnected = true;
  });
  socket.on('refresh', function(){
    console.log("refreshing...");
    localStorage.setItem('scroll-y', String(window.scrollY));

    setTimeout(() => {
      window.location.reload();
    },2000)

    if(!hasOpenedNotifier){
      const newEle = document.createElement('div');
      document.body.appendChild(newEle);
      ReactDOM.render(
      <Toast 
        autoClose={2000} 
        message="Reloading browser..." 
        position="top-right"
      />, 
      newEle)
        hasOpenedNotifier = true;
    }

  });
  socket.on('refresh-fast', function(){
    console.log("refreshing...");
    localStorage.setItem('scroll-y', String(window.scrollY));

    setTimeout(() => {
      window.location.reload();
    },500)

    if(!hasOpenedNotifier){
      const newEle = document.createElement('div');
      document.body.appendChild(newEle);
      ReactDOM.render(
      <Toast 
        autoClose={500} 
        message="Reloading browser..." 
        position="top-right"
      />, 
      newEle)
        hasOpenedNotifier = true;
    }

  });
  socket.on('build', function(){
    console.log("starting build... :) ");
  

    if(!hasOpenedBuildNotifier){
      const newEle = document.createElement('div');
      document.body.appendChild(newEle);
      ReactDOM.render(
      <Toast 
        autoClose={false}
        message="Starting build..." 
        position="top-right"
      />,
      newEle)
        hasOpenedBuildNotifier = true;
    }

  });
  socket.on('reconnect_failed', function reconnectFailed (e: any) {
    if (disconnected) return
    console.error('better wordpress -- connection failed.')
  })


  return true;
})();